


import {SessionDuration} from './SessionDuration'; 
import {SessionType} from './SessionType'; 
import {TimeZoneInfoVM} from './TimeZoneInfoVM'; 
import {SessionCancelStatus} from './SessionCancelStatus'; 
export class SessionBookingVM {
    
    id?: string;
    
    clientName?: string;
    
    counsellorName?: string;
    
    clientUserId?: string;
    
    counsellorUserId?: string;
    
    mbNumber?: string;
    
    date?: Date;
    
    duration?: SessionDuration;
    
    durationInMins?: number;
    
    totalCost?: number;
    
    sessionType?: SessionType;

    sessionTypeAsText?: string;

    sessionId?: string;
    
    pin?: string;
    
    combinedStartDateTime?: Date;
    
    combinedEndDateTime?: Date;
    
    counsellorTZAtBooking?: TimeZoneInfoVM;
    
    token?: string;
    
    cancelStatus?: SessionCancelStatus;
    
    clientProfileImage?: string;
    
    professionalProfileImage?: string;
    
    payWithCredits?: boolean;
    
    orgName?: string;

    orgProfileImage?: string;
    
    paymentRef?: string;
    
}
